var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_658_1091",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.317383,
    width: 40,
    height: 40,
    fill: "#F5F5F5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_658_1091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.6494 28.5602C28.2216 26.0917 26.0212 24.3217 23.4534 23.4827C24.7236 22.7265 25.7104 21.5744 26.2624 20.2031C26.8143 18.8318 26.9009 17.3173 26.5088 15.8921C26.1167 14.4668 25.2676 13.2097 24.0918 12.3138C22.9161 11.4178 21.4788 10.9326 20.0006 10.9326C18.5224 10.9326 17.0851 11.4178 15.9094 12.3138C14.7337 13.2097 13.8846 14.4668 13.4924 15.8921C13.1003 17.3173 13.1869 18.8318 13.7389 20.2031C14.2908 21.5744 15.2777 22.7265 16.5478 23.4827C13.98 24.3208 11.7797 26.0908 10.3519 28.5602C10.2995 28.6455 10.2648 28.7405 10.2497 28.8396C10.2347 28.9386 10.2396 29.0396 10.2642 29.1367C10.2889 29.2338 10.3327 29.3249 10.3931 29.4048C10.4535 29.4847 10.5294 29.5516 10.6161 29.6017C10.7028 29.6518 10.7987 29.684 10.8981 29.6965C10.9974 29.7089 11.0983 29.7013 11.1947 29.6741C11.2911 29.647 11.3811 29.6008 11.4593 29.5382C11.5376 29.4757 11.6025 29.3982 11.6503 29.3102C13.4166 26.2577 16.5384 24.4352 20.0006 24.4352C23.4628 24.4352 26.5847 26.2577 28.3509 29.3102C28.3987 29.3982 28.4637 29.4757 28.5419 29.5382C28.6202 29.6008 28.7101 29.647 28.8065 29.6741C28.9029 29.7013 29.0038 29.7089 29.1032 29.6965C29.2026 29.684 29.2984 29.6518 29.3852 29.6017C29.4719 29.5516 29.5477 29.4847 29.6081 29.4048C29.6686 29.3249 29.7124 29.2338 29.737 29.1367C29.7616 29.0396 29.7666 28.9386 29.7515 28.8396C29.7365 28.7405 29.7017 28.6455 29.6494 28.5602ZM14.7506 17.6852C14.7506 16.6468 15.0585 15.6318 15.6354 14.7684C16.2123 13.9051 17.0322 13.2322 17.9915 12.8348C18.9508 12.4374 20.0064 12.3335 21.0248 12.536C22.0432 12.7386 22.9787 13.2386 23.7129 13.9729C24.4472 14.7071 24.9472 15.6425 25.1497 16.6609C25.3523 17.6793 25.2483 18.7349 24.851 19.6943C24.4536 20.6536 23.7807 21.4735 22.9174 22.0504C22.054 22.6273 21.039 22.9352 20.0006 22.9352C18.6087 22.9337 17.2742 22.3801 16.29 21.3958C15.3057 20.4116 14.7521 19.0771 14.7506 17.6852Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon_user.b6859b9c634d0d1ca170178b0d583d06.svg";
export { ForwardRef as ReactComponent };